<template>
  <div
    class="md:w-4/12 w-full flex flex-col space-y-5 md:mt-0 mt-5 pb-6 template-two-sidebar"
  >
    <div v-if="showSidebarImg" class="customer-sidebar-image">
      <slot name="featured-image"></slot>

      <!-- Need to add quill and make a component here -->
      <slot name="featured-description"></slot>
    </div>
    <div
      class="shadow-lg progress-bar-t2-sidebar btn-radius inter-font-regular"
    >
      <slot v-if="showProgressbar == 1" name="progress-bar"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RightSidebar',
  props: {
    showSidebarImg: {},
    showProgressbar: {},
  },
};
</script>
<style lang="scss">
.template-two-sidebar {
  .customer-sidebar-image {
    .shadow-lg {
      box-shadow: none;
    }
    .btn-radius {
      border-bottom-left-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }
    .lesson-featured-image {
      border-bottom: 1px solid #80808026;
      img {
        height: auto;
      }
    }
  }
  .progress-bar-t2-sidebar {
    .hierarchy-heading-color {
      background: #66c1e1;
    }
  }
  // .instructor-box, .progress-bar-t2-sidebar{
  //   margin-bottom:20px;
  // }
}
</style>